import { FC, SVGProps } from "react";
import { ReactComponent as Default1Icon } from "./assets/default-1.svg";
import { ReactComponent as Default2Icon } from "./assets/default-2.svg";
import { ReactComponent as Default3Icon } from "./assets/default-3.svg";
import { ReactComponent as Default4Icon } from "./assets/default-4.svg";
import { ReactComponent as Default5Icon } from "./assets/default-5.svg";

const DEFAULT_BUTTON_ICONS_DICT: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  "default-1": Default1Icon,
  "default-2": Default2Icon,
  "default-3": Default3Icon,
  "default-4": Default4Icon,
  "default-5": Default5Icon,
};

export const getDefaultButtonIcon = (
  id: string
): FC<SVGProps<SVGSVGElement>> => {
  const matchingIcon =
    DEFAULT_BUTTON_ICONS_DICT[id as keyof typeof DEFAULT_BUTTON_ICONS_DICT];

  if (!matchingIcon) {
    return DEFAULT_BUTTON_ICONS_DICT["default-1"];
  }

  return matchingIcon;
};

export const defaultButtonIconList = Object.keys(
  DEFAULT_BUTTON_ICONS_DICT
).reduce<{ id: string; Icon: FC<SVGProps<SVGSVGElement>> }[]>((acc, key) => {
  acc.push({
    id: key,
    Icon: DEFAULT_BUTTON_ICONS_DICT[
      key as keyof typeof DEFAULT_BUTTON_ICONS_DICT
    ],
  });

  return acc;
}, []);
